export default "__VITE_ASSET__2yrnyF30__"